/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_DInputs */

const en_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program D`)
};

const fr_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme D`)
};

const de_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm D`)
};

const it_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma D`)
};

const ru_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа D`)
};

const es_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa D`)
};

const zh_cn2_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序 D`)
};

const ja_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムD`)
};

const hi_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम डी`)
};

const pt_pt2_subtitle_export_program_d = /** @type {(inputs: Subtitle_Export_Program_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa D`)
};

/**
* | output |
* | --- |
* | "Program D" |
*
* @param {Subtitle_Export_Program_DInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_d = /** @type {((inputs?: Subtitle_Export_Program_DInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_DInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_d(inputs)
	if (locale === "de") return de_subtitle_export_program_d(inputs)
	if (locale === "it") return it_subtitle_export_program_d(inputs)
	if (locale === "ru") return ru_subtitle_export_program_d(inputs)
	if (locale === "es") return es_subtitle_export_program_d(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_d(inputs)
	if (locale === "ja") return ja_subtitle_export_program_d(inputs)
	if (locale === "hi") return hi_subtitle_export_program_d(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_d(inputs)
	return en_subtitle_export_program_d(inputs)
});